var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { Box, Divider } from "@mui/material";
import { Icon, IconName, IconSize } from "@eightfold.ai/octuple";
import AverageScoreProgressBar from "../AverageScoreProgressBar";
import DevelopmentOpportunitiesBar from "../DevelopmentOpportunitiesBar";
import CardTooltip from "../CardTooltip";
import { FilterContext } from "../../providers/FilterProvider";
import { IconPathName } from "../../IconPath/mdi";
var ImpactComponent = function (props) {
    var _a, _b;
    var getFilters = useContext(FilterContext).getFilters;
    var filters = getFilters();
    var arraysEmpty = Object.values(filters)
        .filter(Array.isArray)
        .every(function (arr) { return arr.length === 0; });
    var backgroundAvgScore = function (score) {
        var bgColor;
        if (score >= 90) {
            bgColor = "var(--good-1)";
        }
        else if (score >= 80 && score <= 89) {
            bgColor = "var(--neutral-1)";
        }
        else {
            bgColor = "var(--bad-1)";
        }
        return bgColor;
    };
    var StyledMainWrapper = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    };
    var StyledHeadingText = {
        marginRight: "-14px",
        color: "var(--grey-color-90)",
        fontFamily: "var(--font-stack-full-medium)",
        fontSize: "24px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "32px",
    };
    var StyledScoreText = {
        color: "var(--grey-color-90)",
        fontFamily: "var(--font-stack-full-medium)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
    };
    var StyledAvgScore = {
        display: "flex",
        width: "60px",
        padding: "3px 2px 1px 2px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "10px",
        background: backgroundAvgScore(props === null || props === void 0 ? void 0 : props.avgScore),
        color: "var(--grey-color-90)",
        textAlign: "center",
        fontFamily: "var(--font-stack-full-medium)",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 350,
        lineHeight: "20px",
    };
    var StyledArrow = {
        display: "flex",
        padding: "4px 8px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "24px",
    };
    var StyledAvgBtn = {
        background: "var(--grey-color-10)",
        display: "flex",
        padding: "8px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        borderRadius: "24px",
    };
    var StyledChildWrapper = { width: "48%" };
    var StyledProgressBarWrapper = {
        display: "flex",
        flexDirection: "row",
        marginTop: "44px",
        width: "100%",
        justifyContent: "space-between",
    };
    var title = "Groups with development opportunities";
    var headerIconColor = "var(--bad-1)";
    var colors = ["var(--bad-1)", "var(--neutral-1)", "var(--good-1)"];
    return (_jsxs(Box, { children: [_jsxs(Box, __assign({ sx: __assign(__assign({}, StyledMainWrapper), { justifyContent: "space-between" }) }, { children: [_jsxs(Box, __assign({ sx: StyledMainWrapper }, { children: [_jsx(Box, __assign({ sx: StyledHeadingText }, { children: props === null || props === void 0 ? void 0 : props.heading })), _jsx(Box, __assign({ style: { marginLeft: "20px" } }, { children: _jsx(CardTooltip, { tooltip: "Average ".concat(props === null || props === void 0 ? void 0 : props.heading, " Score for leaders, assessing alignment with\n      ").concat(props === null || props === void 0 ? void 0 : props.heading, " requirements for their current role."), questionIcon: _jsx(Icon, { path: IconPathName.mdiFilledQuestion, style: { color: "var(--grey-color-70)" } }) }) }))] })), _jsx(Box, __assign({ sx: StyledMainWrapper }, { children: _jsxs(Box, __assign({ sx: StyledMainWrapper }, { children: [_jsx(Box, __assign({ sx: __assign(__assign({}, StyledScoreText), { marginRight: "14px" }) }, { children: "Average score" })), _jsxs(Box, __assign({ sx: StyledAvgScore }, { children: [Math.round(props === null || props === void 0 ? void 0 : props.avgScore), "%"] })), _jsxs(Box, __assign({ sx: { marginLeft: "8px", cursor: "pointer" }, onClick: (props === null || props === void 0 ? void 0 : props.avgScoreClick) || (function () { return undefined; }) }, { children: [" ", _jsx(Icon, { size: IconSize.Small, path: IconName.mdiArrowRight, style: StyledAvgBtn })] }))] })) }))] })), _jsxs(Box, __assign({ sx: StyledProgressBarWrapper }, { children: [_jsxs(Box, __assign({ sx: StyledChildWrapper }, { children: [_jsxs(Box, __assign({ sx: StyledMainWrapper }, { children: [_jsxs(Box, { children: [" ", _jsx(Icon, { size: IconSize.Small, path: IconName.mdiArrowUp, style: __assign(__assign({}, StyledArrow), { background: "var(--good-1)" }) })] }), _jsx(Box, __assign({ sx: __assign(__assign({}, StyledScoreText), { fontSize: "20px", marginLeft: "8px", lineHeight: "32px" }) }, { children: "Top strengths" }))] })), (_a = props === null || props === void 0 ? void 0 : props.strengthData) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                                return (_jsx(Box, __assign({ style: { marginBottom: "6px" } }, { children: _jsx(AverageScoreProgressBar, { score: Math.round(item.averagePercentage), title: item.skill, colors: item.colors }) }), index));
                            })] })), _jsxs(Box, __assign({ sx: StyledChildWrapper }, { children: [_jsxs(Box, __assign({ sx: StyledMainWrapper }, { children: [_jsxs(Box, { children: [" ", _jsx(Icon, { size: IconSize.Small, path: IconName.mdiArrowDown, style: __assign(__assign({}, StyledArrow), { background: "var(--bad-1)" }) })] }), _jsx(Box, __assign({ sx: __assign(__assign({}, StyledScoreText), { fontSize: "20px", marginLeft: "8px", lineHeight: "32px" }) }, { children: "Top development opportunities" }))] })), (_b = props === null || props === void 0 ? void 0 : props.weaknessesData) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
                                return (_jsx(Box, __assign({ style: { marginBottom: "6px" } }, { children: _jsx(AverageScoreProgressBar, { score: Math.round(item.averagePercentage), title: item.skill, colors: item.colors }) }), index));
                            })] }))] })), _jsx(Divider, { sx: { margin: "40px 0" } }), arraysEmpty && (_jsx(Box, { children: _jsx(DevelopmentOpportunitiesBar, { title: title, headerIconColor: headerIconColor, colors: colors
                        ? colors
                        : ["var(--bad-1)", "var(--neutral-1)", "var(--good-1)"], data: (props === null || props === void 0 ? void 0 : props.lowestOpportunities) || [] }) }))] }));
};
export default ImpactComponent;
